<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input v-model="attribute.title" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题上偏移">
        <t-input-number v-model="attribute.titleOffsetTop" size="small" :min="-120" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题字体">
        <t-input-number size="small" v-model="attribute.titleSize" :min="1" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.titleColor"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="表盘" :expand="false">
      <t-form-item label="表盘宽度">
        <t-input-number size="small" v-model="attribute.lineWidth" :min="1" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="表盘颜色1">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.color1"/>
      </t-form-item>
      <t-form-item label="表盘颜色2">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.color2"/>
      </t-form-item>
      <t-form-item label="表盘颜色3">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.color3"/>
      </t-form-item>
      <t-form-item label="渐变">
        <t-switch v-model="attribute.enableGradual" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="刻度" :expand="false">
      <t-form-item label="刻度显示">
        <t-switch v-model="attribute.axisTick.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="刻度边距">
        <t-input-number size="small" v-model="attribute.axisTick.distance" :min="-10" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="刻度长度">
        <t-input-number size="small" v-model="attribute.axisTick.length" :min="1" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="刻度值边距">
        <t-input-number size="small" v-model="attribute.axisLabel.distance" :min="-10" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="刻度字体">
        <t-input-number size="small" v-model="attribute.axisLabel.fontSize" :min="1" :max="100" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="指针" :expand="false">
      <t-form-item label="指针长度">
        <t-input-number size="small" v-model="attribute.pointer.length" :min="1" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="指针宽度">
        <t-input-number size="small" v-model="attribute.pointer.width" :min="1" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="指针颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.pointer.itemStyle.color"/>
      </t-form-item>
      <t-form-item label="指针上偏移">
        <t-input-number size="small" v-model="attribute.pointerOffsetTop" :min="-120" :max="120" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="false">
      <t-form-item label="数值区颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemColor"/>
      </t-form-item>
      <t-form-item label="数值字体">
        <t-input-number size="small" v-model="attribute.detailSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="数值颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.detailColor"/>
      </t-form-item>
      <t-form-item label="数值上偏移">
        <t-input-number v-model="attribute.detailOffsetTop" size="small" :min="-120" :max="120" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <t-form-item label="最小值">
      <t-input-number size="small" v-model="attribute.min"/>
    </t-form-item>
    <t-form-item label="最大值">
      <t-input-number size="small" v-model="attribute.max"/>
    </t-form-item>
    <t-form-item label="起始角度">
      <t-input-number size="small" v-model="attribute.startAngle" :min="-360" :max="360" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="结束角度">
      <t-input-number size="small" v-model="attribute.endAngle" :min="-360" :max="360" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="半径%">
      <t-input-number size="small" v-model="attribute.radius" :min="1" :max="110" :decimal-places="0"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-gauge-option",
  components: { CptData },
  props: {
    attribute: Object,
    cptDataForm:Object,
  },
  data(){
    return {
      pointerOffsetTop:0
    }
  }
}
</script>

<style scoped>

</style>
